import React from "react";
import { CssBaseline, Container, Typography, Box } from "@mui/material";
import PostsViews from "./PostsView";
import HeroSlider from "./HeroSlider";
import FeaturedPost from "./FeaturedPost";

export default function MainView() {
  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        <HeroSlider />
        
        {/* Removed top padding `py` and replaced with `pb` to only have bottom padding */}
        <Container maxWidth="lg" sx={{ pb: { xs: 2, md: 4 } }}>
          {/* Added top margin `mt` to control the space from the slider */}
          <Box sx={{ mt: { xs: 2, md: 4 }, mb: { xs: 2, md: 4 } }}>
            <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Featured Story
            </Typography>
            <FeaturedPost />
          </Box>

          {/* Marathon News Section */}
          <Box sx={{ textAlign: 'center', my: { xs: 4, md: 8 } }}>
            <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Marathon News
            </Typography>
            <PostsViews urlProp="categories=1&per_page=3" showPagination={false} />
          </Box>

          {/* Recent Blog Posts Section */}
          <Box sx={{ textAlign: 'center', my: { xs: 4, md: 8 } }}>
            <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
              Recent Blog Posts
            </Typography>
            <PostsViews urlProp="per_page=9" showPagination={false} />
          </Box>
        </Container>
      </main>
    </React.Fragment>
  );
}
